import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDocumentText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <rect
      width={18.008}
      height={18.008}
      x={2.996}
      y={2.996}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={3}
    />
    <rect
      width={3.501}
      height={3.501}
      x={6.998}
      y={6.998}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={0.5}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.5 6.998h3.502M13.5 10.5h3.502M6.998 13.5h10.004M6.998 17.002h10.004"
    />
  </svg>
);
export default SvgDocumentText;
